import GridCardsV2 from './GridCardsV2'
export default GridCardsV2
